import script from "./OfferCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./OfferCard.vue?vue&type=script&lang=ts&setup=true"

import "./OfferCard.vue?vue&type=style&index=0&id=6c026e82&lang=scss"

const __exports__ = script;

export default __exports__